module.exports = __webpack_public_path__ + "img/djzyjz.32ef8d91.png";